
import { useState, type ReactNode } from 'react';
import { PainelSidebar } from './PainelSidebar';
import { PainelTopbar } from './PainelTopbar';
import { PainelSaveFeedbackProvider } from './PainelSaveFeedback';
import { EditorPresenceWatcher } from '@/components/painel/EditorPresenceWatcher';
import { PainelSessionProvider } from '@/components/painel/rbac/painel-session-context';
import { PainelRouteGuard } from '@/components/painel/rbac/PainelAccessDenied';
import { PainelTextsProvider } from '@/components/painel/painel-texts-context';
import { Toaster } from 'sonner';

type PainelShellProps = {
  children: ReactNode;
};

export function PainelShell({ children }: PainelShellProps) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <PainelSessionProvider>
      <PainelTextsProvider>
        <PainelSaveFeedbackProvider>
          <div className="painel-root min-h-screen bg-[#030023] font-inter text-blue-50">
            <div
              className="pointer-events-none fixed inset-0 bg-gradient-to-br from-[#030023] via-[#000b6a]/25 to-[#030023]"
              aria-hidden
            />

            <PainelSidebar
              mobileOpen={mobileSidebarOpen}
              onCloseMobile={() => setMobileSidebarOpen(false)}
            />

            <div className="relative z-10 min-h-screen lg:pl-64">
              <PainelTopbar onOpenSidebar={() => setMobileSidebarOpen(true)} />
              <main className="p-4 md:p-8">
                <PainelRouteGuard>{children}</PainelRouteGuard>
              </main>
            </div>

            <EditorPresenceWatcher />

            <Toaster
              position="bottom-right"
              theme="dark"
              toastOptions={{
                classNames: {
                  toast:
                    'rounded-xl border border-white/10 bg-blue-950/95 font-inter text-slate-100 shadow-xl backdrop-blur-xl',
                  description: 'text-slate-400',
                  title: 'font-poppins font-semibold text-white',
                },
              }}
            />
          </div>
        </PainelSaveFeedbackProvider>
      </PainelTextsProvider>
    </PainelSessionProvider>
  );
}
